<template>
	<div class="row m-0 h-100">
		<div class="form-section col-md-4 col-lg-3 p-0 m-0 h-100">
			<div class="select-user-container d-flex flex-column">
				<label>{{ $t("res_Label_SelectUser") }}</label>
				<StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
						:showInternalStructures="false" :loadOnlyInScopeInternalUsers="false" :loadOnlyInScopeInternalStrucutres="false"  :showExternalStructures="false"
						:excludeSelf="false" :isMultiple="false" :addressBook_header="$t('res_Label_SelectUser')"
						:selectedStructureUser="previewUser" @structureUserSelectChanged="structureUserSelectChanged">
					</StructureUserSelector>
				<div class="p-3 d-flex align-items-center justify-content-end gap-3 position-relative m-0">
					<v-btn color="light-blue" @click="closeDialog()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
					<v-btn class="primary" @click="previewSignatureForSelectedUser">{{ $t("res_ButtonText_Preview") }}</v-btn>
				</div>
			</div>
		</div>
		<div class="viewer-wrapper col-md-8 col-lg-9 h-100 p-0 m-0 h-100">
			<div class="d-flex flex-column h-100">
				<div class=" position-relative viewer-container scrollable-container"
					style="height: calc(104vh - 176px - 1rem); overflow-y: hidden;">
					<div v-if="empty_viewer" class="empty-viewer"
						style="border-radius: 12px; height: calc(100vh - 176px);">
						<img src="/assets/images/icons/template.svg" />
						<img src="/assets/images/icons/no_preview.svg" />
						<p class="mt-4 weight-400">{{ $t("res_Msgs_NoPreviewAvailable") }}</p>
					</div>
					<div v-if="!empty_viewer" id="viewer_template_aireh" class="h-100" style="border-radius: 12px;">
						<iframe id="viewerFrame" :src="templateSource" style="height: 100% !important;" class="w-100"></iframe>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import MultiSelect  from 'vue-multiselect'
	import constants from '@/assets/js/constants.js'
	import axios from 'axios'
    import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed.js'
	import StructureUserSelector from '@/components/StructureUserSelector.vue'

	export default {
		name: 'PreviewSignature',
        components: { MultiSelect, VuePdfEmbed,StructureUserSelector },
        props: {
            documentId: { type: [String, Number], default: '0' },
        },
		data() 
        {
            return {
                loading: false,
				usersList: [],
				previewUser: null,
                templateSource: '',
				empty_viewer: true,
            };
        },
		methods:
		{  
			previewSignatureForSelectedUser()
			{
				if (this.previewUser == null)
				{
					window.showAlert('res_Msgs_SelectUserForSignature', 'warning')
					return
				}

				var url = constants.baseApiUrl + 'Document/PreviewSignature?documentId=' + this.documentId;
				url = url + '&userId=' + (this.previewUser?.id ?? '').split('-')[0] + '&structureId=' + (this.previewUser?.id ?? '').split('-')[1];

				this.templateSource = ''

				window.showLoading()
				axios.post(url, null)
					.then(res => 
					{
						window.clearViewerData();
                        this.templateSource = "/resources/viewer/viewer.html?fileName=" +
												res.data +
												"&lang=" +
												this.$i18n.locale +
												"&defaultScale=page-fit&pageMode=view" +
												"&r=" + new Date().getTime()
						this.empty_viewer = false;
					})
					.catch(err => console.log(err))
					.finally(() => window.hideLoading())
			},
			closeDialog()
			{
				this.$emit('closeDialog')
			},
			structureUserSelectChanged(userSelected){
				this.previewUser = userSelected
			}
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>